import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { scoreDescriptionToLabel } from "../../../detalhes-do-projeto/filtros/score"
import { IScoreVeles } from "../../../../../../../application/models"
// Icon
import CreditScoreIcon from '@mui/icons-material/CreditScore'

export const RecorteScoreFilterPreview = (props: {
    scoreVelesFilter?: IScoreVeles[]
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Score
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.scoreVelesFilter && props.scoreVelesFilter.map((scoreVeles, i) => (
                                <Chip
                                    key={i}
                                    icon={<CreditScoreIcon />}
                                    label={scoreDescriptionToLabel(scoreVeles).toUpperCase()}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}